import EmployeeDetail from "./employeeDetail"
export default EmployeeDetail;
